export function isInAppBrowser(): boolean {
  const ua = navigator.userAgent;
  return /Instagram|FBAN|FBAV/.test(ua);
}

export function inAppBrowserName(): string {
  const ua = navigator.userAgent;
  if (/Instagram/.test(ua)) return 'Instagram';
  if (/FBAN|FBAV/.test(ua)) return 'Facebook';
  return 'приложения';
}

export function isIOS(): boolean {
  return /iPhone|iPad|iPod/.test(navigator.userAgent);
}
